import {useState, useEffect} from 'react'

export type Orientation = 'portrait' | 'landscape'

export function useOrientation(): Orientation {
    const getOrientation = (): Orientation =>
        window.innerHeight > window.innerWidth ? 'portrait' : 'landscape'

    const [orientation, setOrientation] = useState<Orientation>(getOrientation)

    useEffect(() => {
        const handler = () => setOrientation(getOrientation())
        window.addEventListener('resize', handler)
        return () => window.removeEventListener('resize', handler)
    }, [])

    return orientation
}
